/* Rethryv — ambient generative background.
   Slow drifting light in the brand palette, drawn on canvas. Replaces flat
   fills on sections marked [data-flow]. Pauses off-screen, renders a single
   static frame when the visitor prefers reduced motion. */
(function () {
  'use strict';

  var LIGHT = [
    { c: [184, 216, 216], a: 0.55 },   // sky
    { c: [94, 148, 148],  a: 0.26 },   // teal
    { c: [239, 232, 219], a: 0.70 },   // sand
    { c: [255, 255, 255], a: 0.60 },   // light lift
    { c: [184, 216, 216], a: 0.34 },
    { c: [214, 226, 214], a: 0.40 }
  ];
  var DARK = [
    { c: [94, 148, 148],  a: 0.40 },
    { c: [184, 216, 216], a: 0.22 },
    { c: [63, 74, 72],    a: 0.75 },
    { c: [42, 43, 40],    a: 0.80 },
    { c: [94, 148, 148],  a: 0.26 },
    { c: [184, 216, 216], a: 0.16 }
  ];

  function build(host) {
    var dark = host.classList.contains('on-dark') || host.hasAttribute('data-flow-dark');
    var base = dark ? '#22231f' : '#f6f1e2';
    var stops = dark ? DARK : LIGHT;

    var cv = document.createElement('canvas');
    cv.className = 'flow__cv';
    cv.setAttribute('aria-hidden', 'true');
    host.insertBefore(cv, host.firstChild);
    host.classList.add('has-flow');

    var ctx = cv.getContext('2d');
    var w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 1.6);

    // Each blob drifts on its own two sine waves, so the field never repeats
    // in a way the eye can lock onto.
    var blobs = stops.map(function (s, i) {
      return {
        c: s.c, a: s.a,
        ax: 0.16 + (i % 3) * 0.12, ay: 0.14 + (i % 4) * 0.1,
        sx: 0.00007 + i * 0.000024, sy: 0.00009 + i * 0.000019,
        px: (i * 0.19 + 0.1) % 1, py: (i * 0.31 + 0.2) % 1,
        r: 0.42 + (i % 3) * 0.16
      };
    });

    function size() {
      var r = host.getBoundingClientRect();
      w = Math.max(1, r.width); h = Math.max(1, r.height);
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      cv.style.width = w + 'px'; cv.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function frame(t) {
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = base;
      ctx.fillRect(0, 0, w, h);

      var span = Math.max(w, h);
      blobs.forEach(function (b) {
        var x = (b.px + b.ax * Math.sin(t * b.sx)) * w;
        var y = (b.py + b.ay * Math.cos(t * b.sy)) * h;
        var rad = span * b.r;
        var g = ctx.createRadialGradient(x, y, 0, x, y, rad);
        var rgb = b.c[0] + ',' + b.c[1] + ',' + b.c[2];
        g.addColorStop(0, 'rgba(' + rgb + ',' + b.a + ')');
        g.addColorStop(0.55, 'rgba(' + rgb + ',' + (b.a * 0.35) + ')');
        g.addColorStop(1, 'rgba(' + rgb + ',0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(x, y, rad, 0, Math.PI * 2); ctx.fill();
      });
    }

    var raf = null, running = false;
    function loop(now) { frame(now); raf = requestAnimationFrame(loop); }
    function start() { if (!running) { running = true; raf = requestAnimationFrame(loop); } }
    function stop() { if (running) { running = false; cancelAnimationFrame(raf); } }

    size();
    // Always paint once up front. The observer below only starts the loop when
    // the section scrolls into view, so without this a section below the fold
    // renders as an empty transparent block until you reach it.
    frame(performance.now());

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    // only animate what is actually on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { rootMargin: '120px' }).observe(host);
    } else { start(); }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { size(); if (!running) frame(performance.now()); }, 160);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
  }

  function init() { document.querySelectorAll('[data-flow]').forEach(build); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
